import React from "react";
import LatestProject from "../04. Work/projects/project/Project";
import paranotesImage from "./assets/images/JP3HPZ21.webp";
import "../04. Work/Work.css";

const LatestApp = () => {
  return (
    <div className="work-section">
      <div className="work-section-content">
        <h1>Latest App</h1>
        <p className="latest-app">
          Here’s one of my latest creations published on the App Store, feel
          free to check it out{" "}
          <a href="https://apps.apple.com/us/app/paranotes-notes-lists/id6745236653">
            here
          </a>
          .
        </p>
        <LatestProject
          id="latest-app"
          image={paranotesImage}
          title="Paranotes"
          demoLink="https://apps.apple.com/us/app/paranotes-notes-lists/id6745236653"
        />
      </div>
    </div>
  );
};

export default LatestApp;
